import React from "react"
import Logo from "../components/svg/logo"
import { Link } from "gatsby"

export default function HomepageLogoLink({ passedRef, path, classes }) {
  return (
    <Link
      className={"homepage-logo-link" + (classes ? " " + classes : "")}
      to="/"
      aria-current={path === "/" ? "page" : null}
      aria-label="Go to the homepage"
      ref={passedRef ? passedRef : null}
    >
      <Logo />
      <div className="homepage-logo-link__text">
        <div className="homepage-logo-link__text__title">
          Build Forward Better
        </div>
        <div className="homepage-logo-link__text__subtitle">
          IMF Annual Report 2021
        </div>
      </div>
    </Link>
  )
}
